import "@bambus-software-ag/bomify/dist/bomify.css";

import Vue from "vue";
import bomify from "@bambus-software-ag/bomify";
import App from "./App.vue";

import routes from "./plugins/routes.js";

import "@mdi/font/css/materialdesignicons.min.css";

// bom-framework parameters
const bom = {
  api_url: window.bomconfig.api_url,
  api_token: window.bomconfig.api_token,
  client_name: window.bomconfig.client_name,
  client_id: window.bomconfig.client_id,
  language: window.bomconfig.language,
};

Vue.use(bomify, bom);

const de = {
  developed_by: "Entwickelt von <a href='https://bambus-software.ch' noopener noreferrer>Bambus Software</a> und <a href='https://polygon-software.ch/'>PolygonSoftware</a>",
};
const en = {
  developed_by: "Developed by <a href='https://bambus-software.ch' noopener noreferrer>Bambus Software</a> and <a href='https://polygon-software.ch/'>PolygonSoftware</a>",
};
const fr = {
  developed_by: "Développé par <a href='https://bambus-software.ch' noopener noreferrer>Bambus Software</a> et <a href='https://polygon-software.ch/'>PolygonSoftware</a>",
};

const languages = { de, en, fr };

const bomify_plugins = bomify.plugins({ bom, routes, languages });

new Vue({
  ...bomify_plugins,
  render: (h) => h(App),
}).$mount("#bom-regmask");
